export const formatKmCalculados = (kmCalculados) => {
  if (!kmCalculados) return "-";

  const formatNum = (number) => {
    if (number === null || number === undefined || isNaN(number)) return "";
    return new Intl.NumberFormat("en-US", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(number);
  };

  const regex = /distanciaMetros":([\d.]+),"distanciaKms":([\d.]+)/;
  const match = String(kmCalculados).match(regex);

  if (match && match.length >= 3) {
    const distanciaMetros = parseFloat(match[1]);
    const distanciaKms = parseFloat(match[2]);
    
    if (!isNaN(distanciaMetros) && !isNaN(distanciaKms)) {
      return `${formatNum(distanciaKms)} KM (Distancia estimada)`;
    }
  }

  return String(kmCalculados).replace(/"/g, "").replace("km", "").trim();
};